module.exports = __webpack_public_path__ + "img/Carousel3.da16428f.png";